import * as API from '../utilities/api';

export const CLEAR_SELECTED_STATIONS = 'CLEAR_SELECTED_STATIONS';
export const FETCH_STATIONS = 'FETCH_STATIONS';
export const RECEIVE_STATIONS = 'RECEIVE_STATIONS';
export const SELECT_STATION = 'SELECT_STATION';
export const SELECT_EXTRA = 'SELECT_EXTRA';
export const UPDATE_RESTRICTED_TIME_SLOTS = "UPDATE_RESTRICTED_TIME_SLOTS";

export function fetchStations(overwrite) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const state = getState();
      if (state.station.stationsData === null || overwrite) {
        if (state.date.selectedDate === null) {
          reject('No date selected for station selection');
        }
        else {
        
          API.getStations(state.bookingLocation.selectedLocationId, state.date.selectedDate)
            .then((result) => {

              let currentlyOverbooked = false;

              for (let ts of result.timeslots) {
                const selectedItems = state.station.selectedStations[ts.timeslotId];
                const stationsAvailable = ts.availableStations;
                let totalItemsInUse = 0;
                if (ts !== undefined && selectedItems !== undefined) {
                  ts.stationIds.forEach((itemId) => {
                    const itemQuantity = selectedItems[itemId];
                    if (itemQuantity !== undefined) {
                      totalItemsInUse += itemQuantity;
                    }
                  });
                }
                if (totalItemsInUse > stationsAvailable) {
                  currentlyOverbooked = true;
                  break;
                }
              }

              if (currentlyOverbooked) dispatch(clearSelectedStations());
              dispatch(receiveStations(result));
              resolve();
            })
            .catch((error) => {
              console.error('Failed to get stations info: ' + error);
              reject(error);
            });
        }
      }
      else resolve();
    });
  };
}

export function receiveStations(stations) {
  return {
    type: RECEIVE_STATIONS,
    stations
  };
}

export function selectStation(timeslotId, stationId, quantity) {
  return {
    type: SELECT_STATION,
    timeslotId,
    stationId,
    quantity
  };
}

export function selectExtra(timeslotId, stationId, quantity) {
  return {
    type: SELECT_EXTRA,
    timeslotId,
    stationId,
    quantity
  };
}

export function clearSelectedStations() {
  return {
    type: CLEAR_SELECTED_STATIONS
  };
}

export function updateRestrictedTimeSlots(restrictedTimes) {
  return {
    type: UPDATE_RESTRICTED_TIME_SLOTS,
    restrictedTimes
  }
}